export const GROWTH_GLOBAL_NAV = {
  EXPERIMENT_NAME: 'gtb-globalnav-1_0_0',
  VARIATION_A: 'variation_a',
  VARIATION_B: 'variation_b',
  VARIATION_C: 'variation_c',
  VARIATION_D: 'variation_d',
  FEATURE_FLAG: 'gtb_global_nav',
};
